import { SinglePageCard } from '@cart-checkout/data-access/enums';

export class SinglePageCardStatusChangeModel {
  card: SinglePageCard;
  map: Map<string, any>;

  constructor(args: Partial<SinglePageCardStatusChangeModel> = {}) {
    this.card = args.card || SinglePageCard.UNKNOWN;
    this.map = args.map;
  }
}
